import type {DemographicType} from './types';

export default {
	verifyUpc: (upc: string) => `/albums/${upc}/verify-ownership`,
	albumByUPC: (upc: string) => `/album/${upc}`,
	demographics: (upc: string) => `/albums/${upc}/demographics`,
	albumDemographic: (upc: string, type: DemographicType) =>
		`/albums/${upc}/demographics/${type}`,
	albumFans: (upc: string) => `/albums/${upc}/fans`,
	importAlbums: '/import/albums',
	albumPerformances: (upc: string) => `/albums/${upc}/tracks/performances`,
};
